import { render, staticRenderFns } from "./CardUserCoreData.vue?vue&type=template&id=0a40aa7c&scoped=true"
import script from "./CardUserCoreData.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardUserCoreData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/cardUsers/styles/card-user-core-data-style.scss?vue&type=style&index=0&id=0a40aa7c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40aa7c",
  null
  
)

/* custom blocks */
import block0 from "@/components/cardUsers/locales/i18n-card-user-core-data.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FcardUsers%2FCardUserCoreData.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports